import { FormField, NUMBER_REGEX } from 'src/helpers';
import * as Yup from 'yup';

export interface IProject {
  _id: string;
  projectName: string;
  projectType: string;
  systemType: string;
  projectLandType: string;
  projectSize: string;
  price: string;
  salesPrice: string;
  totalProjectPrice: string;
  returnPerYear: string;
  projectOwnershipType: string;
  buildingType: string;
  pricePerKwh: string;
  alignmentOfTheRoofSurface: string;
  numberOfRoofs: string;
  dcCommissioning: string;
  averageAnnualYield: string;
  requiredInvestment: string;
  address: string;
  city: string;
  state: string;
  pinCode: string;
  projectDescription: string;
  contactPersonName: string;
  contactPersonNumber: string;
  attachment: string;
  attachment2: string;
  __v: number;
}

export type IShareProject = {
  userId: string,
  phoneNumber: string
}

export const INIT_SHARE_PROJECT  = {
  userId: "",
  phoneNumber: ""
}

export const INIT_SHARE_PROJECT_VALIDATION_SCHEMA = Yup.object().shape({
  phoneNumber: Yup.string().length(10, 'Phone number is not valid').required('Phone number is required'),
  userId:Yup.string().required('User ID is required'),
});

export const  SHARE_PROJECT_FORM_FIELDS: FormField[] = [
   
    {
        label: 'Enter Phone Number',
        dataKey: 'phoneNumber',
        componentType: 'input',
        componentProps: {
            type: "text",
            regex: NUMBER_REGEX,
            placeholder: 'phone',
            required:true
        },
    },
   
];